import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ChatBot from './components/ChatBot';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import Reminders from './pages/Reminders';
import CityPages from './pages/CityPages';
import Sitemap from './pages/Sitemap';

// Admin Pages
import Login from './pages/Admin/Login';
import Dashboard from './pages/Admin/Dashboard';
import Leads from './pages/Admin/Leads';
import Notifications from './pages/Admin/Notifications';
import Subscribers from './pages/Admin/Subscribers';
import SmsCampaign from './pages/Admin/SmsCampaign';
import Automations from './pages/Admin/Automations';
import Settings from './pages/Admin/Settings';
import './App.css';

// Layout wrapper for public pages to include Header/Footer/ChatBot
const PublicLayout = ({ children }) => (
  <>
    <Header />
    <main>{children}</main>
    <Footer />
    <ChatBot />
  </>
);

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-900 text-white">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/services" element={<PublicLayout><Services /></PublicLayout>} />
          <Route path="/reminders" element={<PublicLayout><Reminders /></PublicLayout>} />
          <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
          <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
          <Route path="/sitemap" element={<PublicLayout><Sitemap /></PublicLayout>} />

          {/* City Pages Routes */}
          <Route path="/ontario-ca" element={<PublicLayout><CityPages city="Ontario" /></PublicLayout>} />
          <Route path="/rancho-cucamonga-ca" element={<PublicLayout><CityPages city="Rancho Cucamonga" /></PublicLayout>} />
          <Route path="/upland-ca" element={<PublicLayout><CityPages city="Upland" /></PublicLayout>} />
          <Route path="/fontana-ca" element={<PublicLayout><CityPages city="Fontana" /></PublicLayout>} />
          <Route path="/chino-ca" element={<PublicLayout><CityPages city="Chino" /></PublicLayout>} />
          <Route path="/pomona-ca" element={<PublicLayout><CityPages city="Pomona" /></PublicLayout>} />
          <Route path="/san-bernardino-ca" element={<PublicLayout><CityPages city="San Bernardino" /></PublicLayout>} />
          <Route path="/riverside-ca" element={<PublicLayout><CityPages city="Riverside" /></PublicLayout>} />

          {/* Admin Routes - No Public Header/Footer - SECURE AREA */}
          <Route path="/admin" element={<Login />} />
          <Route path="/admin/login" element={<Login />} />
          <Route path="/cpanel" element={<Login />} /> {/* Added cPanel shortcut */}
          
          <Route path="/admin/dashboard" element={<Dashboard />} />
          <Route path="/admin/leads" element={<Leads />} />
          <Route path="/admin/notifications" element={<Notifications />} />
          <Route path="/admin/subscribers" element={<Subscribers />} />
          <Route path="/admin/automations" element={<Automations />} />
          <Route path="/admin/sms" element={<SmsCampaign />} />
          <Route path="/admin/settings" element={<Settings />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;